import { createSelector } from 'reselect';
import { subselect } from './root';

export const myAvatarSelector = createSelector(
  [(_, __, globalState) => globalState.chat.avatarUrl],
  (value) => value || '',
);

export const triviaMyAvatarSelector = subselect(myAvatarSelector);
